module.exports = __webpack_public_path__ + "img/9.a324c118.png";